import { StarsButton, Translation } from '@ps/web-shared-components';
import React from 'react';
import { FormattedDate } from 'react-intl';

import PanelItem from '@swf/components/StarsRewards/components/PanelItem/PanelItem';
import PanelItemInfo from '@swf/components/StarsRewards/components/PanelItemInfo/PanelItemInfo';
import type { RewardsEnhanced } from '@swf/core/types/RewardsLegacy';

import ExchangeIcon from '../../assets/exchange.svg';
import ExpiryIcon from '../../assets/expiry.svg';
import UpgradeIcon from '../../assets/upgrade.svg';
// TODO refactor to use composition or shared.scss
// eslint-disable-next-line no-restricted-imports
import styles from '../PanelDropDown/PanelDropDown.scss';

import {
  TXTCLI_Exchange,
  TXTCLI_Exchange_now,
  TXTCLI_Level_N0X_N1_N2_Chests_to_upgr_ELL,
  TXTCLI_Win_N0_Chests_in_a_rolling_N1__ELL,
  TXTCLI_You_can_opt_to_exchange_your_p_ELL,
  TXTCLI_You_have_until_then_to_complet_ELL,
  TXTMOB_ExpiresX
} from './Cvl2Panels.messages.json';

interface Props {
  data: {
    tierId: number;
    cvlConfig: RewardsEnhanced;
    goingToTierDown: boolean;
  };
  togglePanel(panelId: number): void;
  showExchange(): void;
  selectedPanelId?: number;
  panelOpened?: boolean;
}

const Cvl2Panels: React.FC<Props> = ({
  panelOpened,
  selectedPanelId,
  data: { tierId, cvlConfig, goingToTierDown },
  showExchange,
  togglePanel
}) =>
  cvlConfig.cvl2 ? (
    <>
      {cvlConfig.tierUpBars > 0 && !!tierId && tierId < 6 && (
        <PanelItem
          panelId={3}
          isOpened={panelOpened}
          selectedPanelId={selectedPanelId}
          hasInfo
          togglePanel={togglePanel}
        >
          <UpgradeIcon />
          <Translation
            {...TXTCLI_Level_N0X_N1_N2_Chests_to_upgr_ELL}
            values={{
              0: tierId,
              1: cvlConfig.recentBarCounter,
              2: cvlConfig.tierUpBars
            }}
          />

          <PanelItemInfo>
            <Translation
              {...TXTCLI_Win_N0_Chests_in_a_rolling_N1__ELL}
              values={{
                0: cvlConfig.tierUpBars,
                1: cvlConfig.tierUpDays
              }}
            />
          </PanelItemInfo>
        </PanelItem>
      )}

      <PanelItem
        panelId={4}
        isOpened={panelOpened}
        selectedPanelId={selectedPanelId}
        hasInfo
        togglePanel={togglePanel}
      >
        <ExpiryIcon className={cvlConfig.cvl2 && goingToTierDown ? styles.red : undefined} />
        <span>
          <Translation {...TXTMOB_ExpiresX} />
          &nbsp;
          <FormattedDate
            year="numeric"
            month="short"
            day="numeric"
            hour="2-digit"
            minute="2-digit"
            value={cvlConfig.expiresOn}
          />
        </span>

        <PanelItemInfo>
          <Translation {...TXTCLI_You_have_until_then_to_complet_ELL} />
        </PanelItemInfo>
      </PanelItem>

      {cvlConfig.canExchange && (
        <PanelItem
          panelId={5}
          isOpened={panelOpened}
          selectedPanelId={selectedPanelId}
          hasInfo
          togglePanel={togglePanel}
        >
          <ExchangeIcon />
          <Translation {...TXTCLI_Exchange} />

          <PanelItemInfo>
            <Translation {...TXTCLI_You_can_opt_to_exchange_your_p_ELL} />
            <StarsButton
              variant="secondary"
              size="small"
              className={styles.exchange}
              onClick={showExchange}
              translation={TXTCLI_Exchange_now}
            />
          </PanelItemInfo>
        </PanelItem>
      )}
    </>
  ) : null;

export default Cvl2Panels;
